module.exports = __webpack_public_path__ + "img/document-builder-fresh.7b864c6f.png";